import { FC } from 'react';

import { LogoWithText } from '@cloudquery/base-icons';
import Box from '@mui/material/Box';

export const SplashScreen: FC = () => (
  <Box
    data-testid="splash-screen"
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 1400,
    }}
  >
    <Box display="inline-flex">
      <LogoWithText sx={{ height: '48px', width: 'auto' }} />
    </Box>
  </Box>
);
